import { useEffect, useState } from "react";

const Navbar =(props)=>{
    const [isMenuOpen,setIsMenuOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const breakpoint = 1024; // Example breakpoint for mobile vs desktop

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const handleMenuClick = (e) =>{
        console.log("Trying to open the menu");
        setIsMenuOpen(!isMenuOpen);
    }

    const closeMenu = () =>{
        setIsMenuOpen(false);
    }
    
    const maxNavHeight = (props.navItems.length * 48) + 64 + 20;
    
    return(

        <div className="flex flex-col px-10 py-5 gap-5 
                        fixed -translate-x-1/2 w-11/12 left-1/2 top-10
                        rounded-3xl backdrop-blur-md outline outline-1 outline-white/20 bg-white/5 z-50
                        transition-all duration-300"
            style={{
                height:`${isMenuOpen && windowWidth<breakpoint ? `${maxNavHeight}px`: windowWidth>=breakpoint ? "80px" : "64px"}`,
            }}
        >
            
            <div className="flex flex-row justify-between items-center">
                <a onClick={closeMenu} href="#top">
                    <h1 className="text-xl font-black font-roboto lg:text-2xl sm:hidden">
                        {props.logoText}
                    </h1>
                    <h1 className="text-xl font-black font-roboto lg:text-2xl hidden sm:block">
                        {props.logoTextFull}
                    </h1>
                </a>
                <nav>
                    {/* Normal nav */}
                    <div className="hidden lg:flex align items-center justify-around"> 
                        {props.navItems.map((item, index) => (
                            <a onClick={closeMenu} 
                                key={index} 
                                href={item.link} 
                                target={`${item.link.substr(0,4) === "http" ? "_blank" : "" }`}
                                className="p-2 px-4 mx-2 rounded-lg hover:bg-white hover:shadow-md hover:text-black transition-colors delay-20" 
                            >
                                {item.name}
                            </a>
                        ))}
                    </div>
                    
                    {/*Burger Nav button*/}
                    <button 
                        onClick={handleMenuClick} 
                        className="flex flex-col justify-center items-center w-6 h-6 sm:w-8 sm:h-8 relative lg:hidden focus:outline-none"
                    >
                        <span 
                            className={`block absolute h-0.5 w-4 sm:w-6 bg-current transform transition duration-300 ease-in-out ${isMenuOpen ? "rotate-45" : "-translate-y-1.5 sm:-translate-y-2"}`}
                        ></span>
                        <span 
                            className={`block absolute h-0.5 w-4 sm:w-6 bg-current transform transition duration-300 ease-in-out ${isMenuOpen ? "opacity-0" : ""}`}
                        ></span>
                        <span 
                            className={`block absolute h-0.5 w-4 sm:w-6 bg-current transform transition duration-300 ease-in-out ${isMenuOpen ? "-rotate-45" : "translate-y-1.5 sm:translate-y-2"}`}
                        ></span>
                    </button>

                </nav> 
            </div>
            
            {/* Burger Nav */}
            <div className={`${isMenuOpen ? "opacity-100":"opacity-0 collapse"} flex items-center flex-col lg:hidden transition-all gap-2 duration-300`}>
                {props.navItems.map((item, index) => (
                    <a onClick={closeMenu} 
                        key={index}
                        href={item.link} 
                        target={`${item.link.substr(0,4) === "http" ? "_blank" : "" }`}
                        className="p-2" 
                    >
                        {item.name}
                    </a> 
                ))}
            </div>
        </div>
        
    )
}

export default Navbar;